import { usePoSelectedFinanceModels } from '@/services/purchaseOrders/usePurchaseOrderService';
import { usePrintCurrencyStringForCurrentCustomer } from '@/utils/price';
import { FunctionComponent } from 'react';

interface PurchaseOrderConfirmOrderDeviceTablePCMFieldProps {
  categoryId: string;
  manufacturerId: string;
  totalPrice: number;
}

const PurchaseOrderConfirmOrderDeviceTablePCMField: FunctionComponent<
  PurchaseOrderConfirmOrderDeviceTablePCMFieldProps
> = ({ categoryId, manufacturerId, totalPrice }) => {
  const models = usePoSelectedFinanceModels();

  const model = models?.find(model => model.categoryId === categoryId && model.manufacturerId === manufacturerId);

  const printCurrencyString = usePrintCurrencyStringForCurrentCustomer();
  const price = printCurrencyString(totalPrice * (model ? model.pcmFactor : 0));

  return <span>{model && model.pcmFactor ? price : '-'}</span>;
};

export default PurchaseOrderConfirmOrderDeviceTablePCMField;
